export type FailedWorkflowActionsTranslation = {
  table: {
    actionCode: string;
    actions: string;
    error: string;
    offerInstanceId: string;
    processId: string;
    retry: string;
    retryCount: string;
    statusTransition: string;
  };
};

export const failedWorkflowActionsTranslation: FailedWorkflowActionsTranslation = {
  table: {
    actionCode: 'Akcja',
    actions: 'Akcje',
    error: 'Błąd',
    offerInstanceId: 'Oferta',
    processId: 'Proces',
    retry: 'Ponów',
    retryCount: 'Próby',
    statusTransition: 'Przejście statusu',
  },
};
